import smartphone_w from 'src/assets/smartphone-w.png';
import apple_white from 'src/assets/apple-white.png';
import logo from 'src/assets/logo_brand.png';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

import { CForm } from '@coreui/react-pro'
import { useContext, useEffect, useRef, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { APP_CONSTANTS } from 'src/consumer/constants'
import { LoadingSpinner } from 'src/consumer/components/Loaders'
import { PublicAppFooter } from 'src/consumer/components/PublicAppFooter'
import { LocalizationContext } from 'src/consumer/context/LocalizationContext'
import { UnsecureSetupContext } from 'src/consumer/context/UnsecureSetupContext'
import { SEOComponent } from 'src/consumer/helpers/utilFunctions'
import { handleAppleLogin, handleGoogleLogin, handleFacebookLogin } from 'src/consumer/services/loginLogoutHandlers'
import { getData } from 'src/consumer/services/profileService'
import { sendEmailLoginOtp, verifyEmailLoginOtp } from 'src/consumer/services'
import { isBasicOnboardingDone } from 'src/mentor/helpers/utilityFunctions'
import {
  isWellnessRedirectPath,
  preparePostLoginPortalState,
  rememberPortalHandoff,
  resolveDirectPortalHandoff,
  resolvePostLoginNavigation,
} from 'src/shared/auth/loginHandoff'
import {
  getLastLoginActionLabel,
  getLastLoginHandoffUrl,
  getLastLoginHint,
  getLoginMethodLabel,
  isSocialLoginMethod,
  rememberLastLoginHint,
} from 'src/shared/auth/lastLoginHint'
import styled from 'styled-components'
import signinbg from 'src/assets/signin-bg.jpg'
import { SignIn } from '../../../services/APIs/Login/Login'
import './video.css'
import './LoginStyles.css'

function parseStoredConfig(value) {
  if (typeof value !== 'string' || !value.trim()) {
    return null
  }

  try {
    return JSON.parse(value)
  } catch (error) {
    return null
  }
}
import { isValidEmail } from 'src/clinic/views/onboardng/clinicBrand/components/utils'
import { setAccessTokenExpiry } from 'src/consumer/services/localstorageServices';

const LoginPreviousLoginCard = ({ hint, onSelect }) => {
  if (!hint) {
    return null
  }

  const methodLabel = getLoginMethodLabel(hint.method)
  const identifier = hint.identifier || hint.displayName || methodLabel

  return (
    <div className="login-previous-card">
      <div className="login-previous-eyebrow">Previously signed in with {methodLabel}</div>
      <button type="button" className="login-previous-button" onClick={onSelect}>
        <span className="login-previous-identifier">{identifier}</span>
        <span className="login-previous-action">{getLastLoginActionLabel(hint)}</span>
      </button>
      <div className="login-previous-note">You can choose another sign-in method below.</div>
    </div>
  )
}

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  })
  const [errors, setErrors] = useState({
    email: '',
    password: '',
  })
  const navigate = useNavigate()
  const [isLoading, setLoading] = useState(false)
  const [passwordType, setPasswordType] = useState('password')
  const [emailAuthMode, setEmailAuthMode] = useState('password')
  const [emailOtp, setEmailOtp] = useState('')
  const [emailOtpSessionId, setEmailOtpSessionId] = useState(null)
  const [emailOtpExpiry, setEmailOtpExpiry] = useState(0)
  const [emailOtpCountdown, setEmailOtpCountdown] = useState(0)
  const [emailResendCountdown, setEmailResendCountdown] = useState(0)
  const [lang, setLang] = useState([])
  const [apple, setApple] = useState(false)
  const [google, setGoogle] = useState(false)
  const [facebook, setFacebook] = useState(false)
  const [mobile, setmobile] = useState(false)
  const [countryCode, setCountryCode] = useState(localStorage.getItem('countryCode'))
  const [lastLoginHint] = useState(() => getLastLoginHint())
  const emailOtpSendInFlightRef = useRef(false)

  const pageId = 'loginPage'
  const { state } = useLocation()

  const redirectAfterLogin = state?.redirectAfterLogin
  const redirectAfterRegistration = state?.redirectAfterRegistration
  const redirectAfterOnboarding = state?.redirectAfterOnboarding
  const redirectTo = state?.redirectTo
  const redirectData = state?.redirectData
  const mustHaveDoneBasicOnboarding = Boolean(redirectData?.mustHaveDoneBasicOnboarding)

  // so if coming from event booking, and user goes to onboarding from here, we pass state data programatically to /onboarding. then it should be available there.
  // we pass this data to / also. then it should be available there.

  const { localizedDataLoading, localizedData, localizedDataError } =
    useContext(LocalizationContext)
  const localizedStrings = localizedData?.strings?.[pageId]

  const urlParams = new URLSearchParams(window.location.search)

  const resolveDirectLoginHandoff = (authorities) =>
    resolveDirectPortalHandoff(authorities, {
      lastChosenFlow: localStorage.getItem('lastChosenFlow'),
      kioskConfig: parseStoredConfig(localStorage.getItem('kiosk-config')),
      roleCaConfig: parseStoredConfig(localStorage.getItem('ROLE_CA_CONFIG')),
    })

  const resolvePostLoginDestination = (authorities, redirectPath) =>
    resolvePostLoginNavigation(authorities, {
      redirectPath,
      lastChosenFlow: localStorage.getItem('lastChosenFlow'),
      kioskConfig: parseStoredConfig(localStorage.getItem('kiosk-config')),
      roleCaConfig: parseStoredConfig(localStorage.getItem('ROLE_CA_CONFIG')),
    })

  // Validation helpers
  const validateEmail = (email) => {
    if (!email) return localizedStrings?.email_required || 'Email is required'
    if (!isValidEmail(email)) return localizedStrings?.invalid_email || 'Please enter a valid email address'
    return ''
  }

  const validatePassword = (password) => {
    if (!password) return localizedStrings?.password_required || 'Password is required'
    if (password.length < 6) return localizedStrings?.password_min_length || 'Password must be at least 6 characters'
    return ''
  }

  const resolveRetryAfterSeconds = (payload, fallback = 60) => {
    if (!payload) {
      return fallback
    }
    const retryAfter = Number(payload.retryAfter)
    if (Number.isFinite(retryAfter) && retryAfter > 0) {
      return retryAfter
    }
    if (payload.resendAvailableAt) {
      const resendTime = new Date(payload.resendAvailableAt).getTime()
      if (!Number.isNaN(resendTime)) {
        return Math.max(1, Math.ceil((resendTime - Date.now()) / 1000))
      }
    }
    return fallback
  }

  const resetEmailOtpState = () => {
    setEmailAuthMode('password')
    setEmailOtp('')
    setEmailOtpSessionId(null)
    setEmailOtpExpiry(0)
    setEmailOtpCountdown(0)
    setEmailResendCountdown(0)
  }

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }))
    if (field === 'email' && emailAuthMode === 'otp') {
      resetEmailOtpState()
    }
    // Clear error when user starts typing
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: '' }))
    }
  }

  const validateForm = () => {
    const emailError = validateEmail(formData.email)
    const passwordError = validatePassword(formData.password)
    setErrors({ email: emailError, password: passwordError })
    return !emailError && !passwordError
  }

  const togglePassword = () => {
    setPasswordType((prev) => (prev === 'password' ? 'text' : 'password'))
  }

  const handlePostLogin = async (response, loginHint) => {
    if (response?.status === 200) {
      const { accessToken, authorities, accessTokenExpiry } = response.data
      localStorage.setItem('token', accessToken)
      setAccessTokenExpiry({ accessTokenExpiry })
      localStorage.setItem('authorities', JSON.stringify(authorities))
      if (loginHint) {
        rememberLastLoginHint(loginHint)
      }
      const postLoginDestination = resolvePostLoginDestination(
        authorities,
        redirectAfterLogin ? redirectTo : null,
      )
      preparePostLoginPortalState({
        explicitWellness: postLoginDestination.portalId === 'consumer' ||
          (postLoginDestination.portalId === 'redirect' &&
            isWellnessRedirectPath(postLoginDestination.path)),
      })
      
      if (redirectAfterLogin) {
        if (mustHaveDoneBasicOnboarding) {
          try {
            const resp = await getData('/api/secure/user/profile')
            if (resp?.status === 200) {
              if (isBasicOnboardingDone(resp.data)) {
                if (postLoginDestination.portalId === 'redirect') {
                  navigate(postLoginDestination.path, { state: state })
                } else {
                  navigate(postLoginDestination.path || '/portals', {})
                }
              } else {
                navigate('/onboarding', { state: state })
              }
            } else {
              navigate(postLoginDestination?.path || '/portals', {})
            }
          } catch (error) {
            navigate(postLoginDestination?.path || '/portals', {})
          }
        } else {
          if (postLoginDestination.portalId === 'redirect') {
            navigate(postLoginDestination.path, { state: state })
          } else {
            navigate(postLoginDestination.path || '/portals', {})
          }
        }
      } else {
        if (postLoginDestination?.portalId) {
          rememberPortalHandoff(postLoginDestination.portalId)
        }
        navigate(postLoginDestination?.path || '/portals', {})
      }
      window.dispatchEvent(new Event('storage'))
      toast.success(localizedStrings?.login_success || 'Logged in successfully!')
    } else {
      const errorMessage = response?.data?.message || localizedStrings?.invalid_credentials || 'Invalid credentials. Please check your email and password.'
      setErrors({ email: errorMessage, password: '' })
      toast.error(errorMessage)
    }
    setLoading(false)
  }

  const handleSendEmailCode = async () => {
    if (emailOtpSendInFlightRef.current) {
      return
    }
    const emailError = validateEmail(formData.email)
    setErrors({ email: emailError, password: '' })
    if (emailError) {
      toast.error(emailError)
      return
    }

    emailOtpSendInFlightRef.current = true
    setLoading(true)
    try {
      const response = await sendEmailLoginOtp(formData.email.trim())
      if (response?.status === 200 && response?.data?.success) {
        const otpExpiry = response.data.otpExpiry || 300
        const resendDelay = resolveRetryAfterSeconds(response.data, 60)
        setEmailAuthMode('otp')
        setEmailOtp('')
        setEmailOtpSessionId(response.data.sessionId)
        setEmailOtpExpiry(otpExpiry)
        setEmailOtpCountdown(otpExpiry)
        setEmailResendCountdown(resendDelay)
        toast.success(response.data.message || 'Code sent successfully to your email.')
      } else {
        const errorData = response?.response?.data || response?.data || {}
        const retryAfter = resolveRetryAfterSeconds(errorData, 60)
        const errorMessage =
          errorData?.errorCode === 'RATE_LIMIT_EXCEEDED'
            ? `Too many code requests. Please try again after ${retryAfter} seconds.`
            : errorData?.message || 'Unable to send email code right now.'
        setErrors({ email: errorMessage, password: '' })
        if (errorData?.errorCode === 'RATE_LIMIT_EXCEEDED') {
          setEmailResendCountdown(retryAfter)
        }
        toast.error(errorMessage)
      }
    } catch (error) {
      const errorData = error?.response?.data || {}
      const retryAfter = resolveRetryAfterSeconds(errorData, 60)
      const errorMessage =
        error?.response?.status === 429 || errorData?.errorCode === 'RATE_LIMIT_EXCEEDED'
          ? `Too many code requests. Please try again after ${retryAfter} seconds.`
          : errorData?.message || 'Unable to send email code right now.'
      setErrors({ email: errorMessage, password: '' })
      if (error?.response?.status === 429 || errorData?.errorCode === 'RATE_LIMIT_EXCEEDED') {
        setEmailResendCountdown(retryAfter)
      }
      toast.error(errorMessage)
    } finally {
      emailOtpSendInFlightRef.current = false
      setLoading(false)
    }
  }

  const handlePreviousLoginHintSelect = () => {
    if (!lastLoginHint) {
      return
    }

    setErrors({ email: '', password: '' })
    resetEmailOtpState()

    if (isSocialLoginMethod(lastLoginHint.method)) {
      if (lastLoginHint.method === 'google') {
        handleGoogleLogin(handlePostLogin)
      } else if (lastLoginHint.method === 'facebook') {
        handleFacebookLogin(handlePostLogin)
      } else if (lastLoginHint.method === 'apple') {
        handleAppleLogin(handlePostLogin)
      }
      return
    }

    if (lastLoginHint.method === 'mobile' || lastLoginHint.method === 'whatsapp') {
      navigate(getLastLoginHandoffUrl(lastLoginHint))
      return
    }

    setFormData({
      email: lastLoginHint.identifier || '',
      password: '',
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setErrors({ email: '', password: '' })

    const form = e.currentTarget
    const submittedFormData = new FormData(form)
    const submittedEmail = String(submittedFormData.get('email') || '').trim()
    const submittedPassword = String(submittedFormData.get('password') || '')
    const submittedCredentials = {
      email: submittedEmail,
      password: submittedPassword,
    }
    setFormData(submittedCredentials)

    const emailError = validateEmail(submittedCredentials.email)
    const passwordError =
      emailAuthMode === 'otp' ? '' : validatePassword(submittedCredentials.password)
    setErrors({ email: emailError, password: passwordError })

    if (emailError || passwordError) {
      return
    }

    setLoading(true)
    try {
      if (emailAuthMode === 'otp') {
        if (!emailOtpSessionId) {
          const errorMessage = 'Session expired. Please request a new code.'
          setErrors({ email: errorMessage, password: '' })
          toast.error(errorMessage)
          resetEmailOtpState()
          setLoading(false)
          return
        }
        const response = await verifyEmailLoginOtp(submittedCredentials.email, emailOtp, emailOtpSessionId)
        if (response?.status === 200) {
          handlePostLogin(response, { method: 'email', identifier: submittedCredentials.email })
          return
        }

        const errorData = response?.response?.data || response?.data || {}
        const errorMessage = errorData?.message || localizedStrings?.login_error || 'Invalid code. Please try again.'
        setErrors({ email: errorMessage, password: '' })
        if (['OTP_EXPIRED', 'SESSION_NOT_FOUND', 'MAX_ATTEMPTS_EXCEEDED'].includes(errorData?.errorCode)) {
          resetEmailOtpState()
        }
        toast.error(errorMessage)
        setLoading(false)
        return
      }

      const response = await SignIn(submittedCredentials.email, submittedCredentials.password)
      handlePostLogin(response, { method: 'email', identifier: submittedCredentials.email })
    } catch (error) {
      setLoading(false)
      const errorMessage = error?.response?.data?.message || localizedStrings?.login_error || 'An error occurred. Please try again.'
      setErrors({ email: errorMessage, password: '' })
      toast.error(errorMessage)
    }
  }

  const { unSecureSetupLoading, unSecureSetupData, unSecureSetupError } =
    useContext(UnsecureSetupContext)

  const setup = async () => {
    setLang(unSecureSetupData?.appLanguages || [])
    setApple(unSecureSetupData?.loginPolicy.login.apple)
    setGoogle(unSecureSetupData?.loginPolicy.login.google)
    setFacebook(unSecureSetupData?.loginPolicy.login.facebook)
    setmobile(unSecureSetupData?.loginPolicy.login.mobile)
  }

  useEffect(() => {
    if (localStorage.getItem('token')) {
      const authorities = localStorage.getItem('authorities')
      const directPortalHandoff = resolveDirectLoginHandoff(authorities)

      if (directPortalHandoff?.path) {
        preparePostLoginPortalState()
        rememberPortalHandoff(directPortalHandoff.portalId)
        navigate(directPortalHandoff.path)
        return
      }

      preparePostLoginPortalState()
      navigate(resolvePostLoginDestination(authorities)?.path || '/portals')
    }
  }, [])

  useEffect(() => {
    setup()
  }, [countryCode, unSecureSetupData])

  useEffect(() => {
    function handleChangeStorage() {
      setCountryCode(localStorage.getItem('countryCode'))
    }

    window.addEventListener('storage', handleChangeStorage)
    return () => window.removeEventListener('storage', handleChangeStorage)
  }, [])

  useEffect(() => {
    if (emailOtpCountdown <= 0 || emailAuthMode !== 'otp') {
      return undefined
    }
    const interval = window.setInterval(() => {
      setEmailOtpCountdown((prev) => (prev <= 1 ? 0 : prev - 1))
    }, 1000)
    return () => window.clearInterval(interval)
  }, [emailOtpCountdown, emailAuthMode])

  useEffect(() => {
    if (emailResendCountdown <= 0 || emailAuthMode !== 'otp') {
      return undefined
    }
    const interval = window.setInterval(() => {
      setEmailResendCountdown((prev) => (prev <= 1 ? 0 : prev - 1))
    }, 1000)
    return () => window.clearInterval(interval)
  }, [emailResendCountdown, emailAuthMode])

  if (unSecureSetupLoading) {
    return <LoadingSpinner />
  }

  return (
    <>
      <SEOComponent
        title="Sign In to Your Mental Wellness Hub | AUMHUM"
        description={APP_CONSTANTS.DEFAULT_DESCRIPTION}
        image={APP_CONSTANTS.APP_LOGO_LINK}
        keywordsArr={['sign in', 'log in', 'wellness']}
      />
      <div className="login-page">
        <div className="login-background">
          <img className="login-background-image" src={signinbg} alt="Background" />
          <div className="login-background-overlay" aria-hidden="true"></div>
        </div>
        <div className="login-container">
          <header className="login-header">
            <Link to={'/'} className="login-logo-container">
              <div className="login-logo">
                <img 
                  src={APP_CONSTANTS.APP_LOGO_LINK} 
                  alt="AUMHUM Logo" 
                  onError={(e) => {
                    e.target.src = logo
                  }}
                />
              </div>
              {countryCode && (
                <span className="login-country-code">{countryCode.toUpperCase()}</span>
              )}
            </Link>

            <div className="login-header-actions">
              {lang.length > 0 && (
                <div className="login-language-selector">
                  <select
                    onChange={(e) => {
                      sessionStorage.setItem('languageCode', e.target.value)
                      window.location.reload()
                    }}
                    value={sessionStorage.getItem('languageCode') || 'default'}
                    className="login-language-select"
                    aria-label="Select language"
                  >
                    <option value="default" disabled>
                      {localizedStrings?.language || 'Language'}
                    </option>
                    {lang.map((item) => (
                      <option value={item.id} key={item.id}>
                        {item.localLanguageName}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              <button
                className="login-signup-button"
                onClick={() => {
                  if (redirectAfterRegistration || redirectAfterOnboarding) {
                    navigate('/onboarding', { state: state })
                  } else {
                    navigate('/onboarding')
                  }
                }}
              >
                {localizedStrings?.sign_up_for_aumhum || 'Sign up for AUMHUM'}
              </button>
            </div>
          </header>
          <main className="login-main">
            <div className="login-card">
              <div className="login-card-header">
                <h1 className="login-title">{localizedStrings?.sign_in || 'Sign in'}</h1>
                <p className="login-subtitle">
                  {localizedStrings?.to_get_access_to_the_courses ||
                    'Welcome back! Please enter your credentials'}
                </p>
              </div>

              {lastLoginHint && (
                <LoginPreviousLoginCard
                  hint={lastLoginHint}
                  onSelect={handlePreviousLoginHintSelect}
                />
              )}

              <CForm onSubmit={handleSubmit} className="login-form">
                {/* Email Field */}
                <div className="login-field-group">
                  <label htmlFor="email" className="login-label">
                    {localizedStrings?.email || 'Email Address'}
                  </label>
                  <input
                    id="email"
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={(e) => handleInputChange('email', e.target.value)}
                    placeholder={localizedStrings?.email_placeholder || 'Enter your email'}
                    className={`login-input ${errors.email ? 'login-input-error' : ''}`}
                    aria-invalid={!!errors.email}
                    aria-describedby={errors.email ? 'email-error' : undefined}
                    disabled={isLoading}
                    autoComplete="email"
                  />
                  {errors.email && (
                    <span id="email-error" className="login-error" role="alert">
                      {errors.email}
                    </span>
                  )}
                </div>

                {/* Password Field */}
                <div className="login-field-group">
                  <label htmlFor={emailAuthMode === 'otp' ? 'email-otp' : 'password'} className="login-label">
                    {emailAuthMode === 'otp'
                      ? localizedStrings?.verification_code || 'Verification Code'
                      : localizedStrings?.password || 'Password'}
                  </label>
                  {emailAuthMode === 'otp' ? (
                    <>
                      <input
                        id="email-otp"
                        type="text"
                        name="email-otp"
                        inputMode="numeric"
                        maxLength={8}
                        value={emailOtp}
                        onChange={(e) => setEmailOtp(e.target.value.replace(/\D/g, '').slice(0, 8))}
                        placeholder="Enter the code from your email"
                        className={`login-input ${errors.password ? 'login-input-error' : ''}`}
                        aria-invalid={!!errors.password}
                        aria-describedby={errors.password ? 'password-error' : undefined}
                        disabled={isLoading}
                        autoComplete="one-time-code"
                      />
                      <div className="login-otp-note">
                        <span>Code sent to {formData.email}</span>
                        <button
                          type="button"
                          className="login-inline-link"
                          onClick={resetEmailOtpState}
                          disabled={isLoading}
                        >
                          Use password
                        </button>
                      </div>
                      <div className="login-otp-note login-otp-note-muted">
                        {emailOtpCountdown > 0 && (
                          <span>
                            Code expires in {Math.floor(emailOtpCountdown / 60)}:{String(emailOtpCountdown % 60).padStart(2, '0')}
                          </span>
                        )}
                        {emailResendCountdown > 0 ? (
                          <span>Resend in {emailResendCountdown}s</span>
                        ) : (
                          <button
                            type="button"
                            className="login-inline-link"
                            onClick={handleSendEmailCode}
                            disabled={isLoading}
                          >
                            Resend code
                          </button>
                        )}
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="login-password-wrapper">
                        <input
                          id="password"
                          type={passwordType}
                          name="password"
                          value={formData.password}
                          onChange={(e) => handleInputChange('password', e.target.value)}
                          placeholder={localizedStrings?.password_placeholder || 'Enter your password'}
                          className={`login-input login-input-password ${errors.password ? 'login-input-error' : ''}`}
                          aria-invalid={!!errors.password}
                          aria-describedby={errors.password ? 'password-error' : undefined}
                          disabled={isLoading}
                          autoComplete="current-password"
                        />
                        <button
                          type="button"
                          onClick={togglePassword}
                          className="login-password-toggle"
                          aria-label={passwordType === 'password' ? 'Show password' : 'Hide password'}
                          disabled={isLoading}
                        >
                          {passwordType === 'password' ? (
                            <AiFillEyeInvisible aria-hidden="true" />
                          ) : (
                            <AiFillEye aria-hidden="true" />
                          )}
                        </button>
                      </div>
                      {errors.password && (
                        <span id="password-error" className="login-error" role="alert">
                          {errors.password}
                        </span>
                      )}
                    </>
                  )}
                </div>

                {/* Forgot Password */}
                <div className="login-options">
                  {emailAuthMode === 'password' ? (
                    <button
                      type="button"
                      className="login-inline-link"
                      onClick={handleSendEmailCode}
                      disabled={isLoading}
                    >
                      Email me a code instead
                    </button>
                  ) : (
                    <div></div>
                  )}
                  <Link
                    to={
                      isValidEmail(formData.email)
                        ? `/forgot-password?email=${formData.email}`
                        : `/forgot-password`
                    }
                    className="login-forgot-password"
                  >
                    {localizedStrings?.forgot_password || 'Forgot Password?'}
                  </Link>
                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  className="login-submit-button"
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <Spinner animation="border" variant="dark" size="sm" className="me-2" />
                      {emailAuthMode === 'otp'
                        ? localizedStrings?.verifying || 'Verifying...'
                        : localizedStrings?.signing_in || 'Signing in...'}
                    </>
                  ) : (
                    emailAuthMode === 'otp'
                      ? localizedStrings?.verify_and_continue || 'Verify & Continue'
                      : localizedStrings?.sign_in || 'Sign in'
                  )}
                </button>
              </CForm>

                {/* <div className="w-100 m-4" style={{textAlign:"center"}}>
                  <div className=" d-flex flex-column w-100 my-3 text-white">
                    <p className="w-6 h-6 bg-gray-700" style={{padding: "0.125rem", fontSize: "0.875rem",alignItems:"center", display: "flex", borderRadius: "50%"}}>
                      {localizedStrings?.or || 'or'}
                    </p>
                  </div>
                </div> */}

              {/* Social Login Divider */}
              {(google || apple || facebook || mobile) && (
                <>
                  <div className="login-divider">
                    <span className="login-divider-text">
                      {localizedStrings?.or || 'or'}
                    </span>
                  </div>

                  {/* Social Login Buttons */}
                  <div className="login-social-buttons">
                    {mobile && (
                      <button
                        type="button"
                        onClick={() => navigate('/?lt=t')}
                        className="login-social-button"
                        aria-label="Sign in with mobile"
                        disabled={isLoading}
                      >
                        <img src={smartphone_w} alt="Mobile" />
                      </button>
                    )}
                    {mobile && (
                      <button
                        type="button"
                        onClick={() => navigate('/?lt=w')}
                        className="login-social-button"
                        aria-label="Sign in with WhatsApp"
                        disabled={isLoading}
                      >
                        <WhatsAppIcon sx={{ fontSize: '28px', color: '#25D366' }} />
                      </button>
                    )}
                    {google && (
                      <button
                        type="button"
                        onClick={() => handleGoogleLogin(handlePostLogin)}
                        className="login-social-button"
                        aria-label="Sign in with Google"
                        disabled={isLoading}
                      >
                        <img src="google-colored.png" alt="Google" />
                      </button>
                    )}
                    {facebook && (
                      <button
                        type="button"
                        onClick={() => handleFacebookLogin(handlePostLogin)}
                        className="login-social-button"
                        aria-label="Sign in with Facebook"
                        disabled={isLoading}
                      >
                        <img src="facebook-colored.png" alt="Facebook" />
                      </button>
                    )}
                    {apple && (
                      <button
                        type="button"
                        onClick={() => handleAppleLogin(handlePostLogin)}
                        className="login-social-button"
                        aria-label="Sign in with Apple"
                        disabled={isLoading}
                      >
                        <img src={apple_white} alt="Apple" />
                      </button>
                    )}
                  </div>
                </>
              )}
            </div>
          </main>
        </div>
      </div>
      <PublicAppFooter />
    </>
  )
}

export default Login

export const LoginDividerContainer = styled.div`
  width: 100%;
  color: white;
  display: flex;
  justify-content: center;
  position: relative;
`

export const LoginDividerLine = styled.hr`
  width: 100%;
  position: absolute;
  margin: 0;
  top: 50%;
  border-top: 2px solid white;
  opacity: 1;
`

export const DividerText = styled.p`
  width: 1.5rem;
  height: 1.5rem;
  background: #4b5563;
  padding: 13px;
  font-size: 0.875rem;
  margin: auto;
  border-radius: 50%;
  text-align: center;
  line-height: 1.5rem;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
`
